export const getBOPISFreeGiftAvailabilityStoresSelector = state => state.bopisReducer.getBOPISFreeGiftAvailabilityStoresReducer;
